import { booleanPointInPolygon, polygon as createPolygon, lineSplit, lineString } from "@turf/turf";
import type { Position } from "geojson";
import type { XY } from "@designboticteam/core";
import { toClosedPolygon } from "./toClosedPolygon";

// The line is cut where it crosses the boundary, so each remaining segment lies fully inside or
// fully outside and its midpoint decides. Touching the boundary counts as inside, like isPolygonInsidePolygon.
function isPolylineInsidePolygon(line: Array<XY>, polygon: Array<XY>): boolean {
	const ring = toClosedPolygon(polygon);

	if (ring === null || line.length === 0) {
		return false;
	}

	const area = createPolygon([ring]);
	const pieces = lineSplit(lineString(line), area).features;
	const paths: Array<Array<Position>> = pieces.length > 0 ? pieces.map((piece) => piece.geometry.coordinates) : [line];

	return paths.every((path) =>
		path.every((point, index) => {
			if (booleanPointInPolygon(point, area) === false) {
				return false;
			}

			if (index === 0) {
				return true;
			}

			const previous = path[index - 1];
			return booleanPointInPolygon([(point[0] + previous[0]) / 2, (point[1] + previous[1]) / 2], area);
		}),
	);
}

export { isPolylineInsidePolygon };
